import type { IChangeEmail } from "@src/types/AppTypes";
import { createContext } from "react";

export const ChangeEmailContext = createContext<{
  emailData: IChangeEmail;
  setEmailData: React.Dispatch<{ payload: IChangeEmail; type: "changeEmail" }>;
}>({
  emailData: { email: "", password: "" },
  setEmailData: () => {},
});

export function changeEmailReducer(
  state: IChangeEmail,
  action: { payload: IChangeEmail; type: "changeEmail" }
) {
  if (action.type === "changeEmail") {
    return action.payload;
  } else {
    return state;
  }
}
